var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34px",
    height: "24px",
    viewBox: "0 0 34 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "9FDD7F47-EAC9-4554-B856-879DC2BFC87C") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web-1366",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Client_states",
    transform: "translate(-119.000000, -690.000000)",
    fill: "#1B39CE",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Buttons-&-actions",
    transform: "translate(60.000000, 60.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Upload-files",
    transform: "translate(0.000000, 608.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Upload_file_default-"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cloud-upload-light",
    transform: "translate(59.000000, 22.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6015625,7.3125 C16.351875,7.06071429 15.948125,7.06071429 15.6984375,7.3125 L10.47625,12.5785714 C10.2265625,12.8303571 10.2265625,13.2375 10.47625,13.4892857 L10.7790625,13.7946429 C11.02875,14.0464286 11.4325,14.0464286 11.6821875,13.7946429 L15.3053125,10.1410714 L15.3053125,18.2142857 C15.3053125,18.5678571 15.5921875,18.8571429 15.9428125,18.8571429 L16.3678125,18.8571429 C16.7184375,18.8571429 17.0053125,18.5678571 17.0053125,18.2142857 L17.0053125,10.1410714 L20.6284375,13.7946429 C20.878125,14.0464286 21.281875,14.0464286 21.5315625,13.7946429 L21.834375,13.4892857 C22.0840625,13.2375 22.0840625,12.8303571 21.834375,12.5785714 L16.6015625,7.3125 Z M30.3715625,11.0785714 C30.5203125,10.5482143 30.6,9.99642857 30.6,9.42857143 C30.6,6.1125 27.9384375,3.42857143 24.65,3.42857143 C23.7628125,3.42857143 22.9021875,3.62142857 22.1,4.00714286 C20.42125,1.59642857 17.6215625,0 14.45,0 C9.435,0 5.3284375,3.99107143 5.110625,9.01071429 C2.0825,10.0821429 0,12.9803571 0,16.2857143 C0,20.55 3.42125,24 7.65,24 L27.2,24 C30.9559375,24 34,20.9357143 34,17.1428571 C34,14.625 32.629375,12.2785714 30.3715625,11.0785714 Z M27.2,22.2857143 L7.65,22.2857143 C4.3615625,22.2857143 1.7,19.6017857 1.7,16.2857143 C1.7,13.2428571 3.941875,10.7303571 6.853125,10.3392857 C6.8159375,10.0392857 6.8,9.73392857 6.8,9.42857143 C6.8,5.16964286 10.2265625,1.71428571 14.45,1.71428571 C17.6534375,1.71428571 20.3946875,3.69642857 21.536875,6.51428571 C22.3125,5.67321429 23.4175,5.14285714 24.65,5.14285714 C26.998125,5.14285714 28.9,7.06071429 28.9,9.42857143 C28.9,10.4196429 28.5653125,11.3357143 28.0021875,12.0642857 C30.440625,12.45 32.3,14.5767857 32.3,17.1428571 C32.3,19.9821429 30.015625,22.2857143 27.2,22.2857143 Z",
    id: "Shape"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.110507be.svg";
export { ForwardRef as ReactComponent };